import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../shared/services/base.service';
import { environment } from 'src/environments/environment';

export interface AuthServiceConfig {
    id: number;
    name: string;
    color?: string;
    imageUid?: string;
    imageUrl?: string;
    webapp_enabled?: boolean;
}

export interface AuthMethod {
    id: number;
    name: string;
    enabled: boolean;
}

/**
 * Service for managing OAuth/external authentication services
 * Provides operations for auth service configurations
 */
@Injectable({
    providedIn: 'root'
})
export class AuthServicesService extends BaseService<AuthServiceConfig> {

    /**
     * Get all configured authentication services (OAuth providers)
     * @returns Observable with auth services list
     */
    getAuthServices(): Observable<AuthServiceConfig[]> {
        return this.http.get<AuthServiceConfig[]>(`${environment.config.api_url}Auth/services`);
    }

    /**
     * Get authentication methods available
     * @returns Observable with auth methods list
     */
    getAuthMethods(): Observable<AuthMethod[]> {
        return this.http.get<AuthMethod[]>(`${environment.config.api_url}Auth/Methods`);
    }

    /**
     * Build the image URL for an auth service
     * @param imageUid The image UID
     * @returns Full URL to download the image
     */
    getImageUrl(imageUid: string): string {
        return `${environment.config.api_url}Files/${imageUid}/download`;
    }
}
